import { render } from "./billViewer.vue?vue&type=template&id=2a0029b5&scoped=true"
import script from "./billViewer.vue?vue&type=script&lang=js"
export * from "./billViewer.vue?vue&type=script&lang=js"

import "./billViewer.vue?vue&type=style&index=0&id=2a0029b5&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0029b5"]])

export default __exports__